export const RTM_LEARNER_SELECTED_THEME_GET = 'learner.selected.theme.get';
export const RTM_LEARNER_SELECTED_THEME_GET_OK = 'learner.selected.theme.get.ok';
export const RTM_LEARNER_SELECTED_THEME_GET_ERROR = 'learner.selected.theme.get.error';

export const RTM_LEARNER_THEME_VARIANT_GET = 'learner.theme.variant.get';
export const RTM_LEARNER_THEME_VARIANT_GET_OK = 'learner.theme.variant.get.ok';
export const RTM_LEARNER_THEME_VARIANT_GET_ERROR = 'learner.theme.variant.get.error';
